export type Bonus = {
  number: string
  name: string
  summary: string
  includes: string
  idealFor: string
  value: number
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    name: 'Mobility for All Joints',
    summary: 'Full-body mobility exercises organized for the major joints and movement regions of the body.',
    includes:
      'Includes practical routines for shoulders, elbows, wrists, spine, hips, knees and ankles, with short mobility sequences and complete full-body options.',
    idealFor: 'Ideal for warm-up, movement preparation and general mobility work.',
    value: 12,
  },
  {
    number: '02',
    name: 'Rehabilitation at Home',
    summary: 'A practical home-based exercise system using bodyweight and simple equipment.',
    includes:
      'Includes exercises with resistance bands, a chair, wall, towel and other easy-to-use resources, organized for different body areas and levels.',
    idealFor: 'Perfect for continuing mobility, control and strengthening work without gym equipment.',
    value: 12,
  },
  {
    number: '03',
    name: 'Rehabilitation at the Gym',
    summary: 'Progressive rehabilitation and strengthening exercises using common gym equipment.',
    includes:
      'Includes machines, cables, dumbbells, resistance bands and benches, with options for upper body, lower body and complete gym-based routines.',
    idealFor: 'Designed to help organize progressive resistance work in a clear and practical way.',
    value: 15,
  },
  {
    number: '04',
    name: 'Joint Prevention & Strengthening',
    summary: 'A practical joint-capacity system focused on strength, stability, control and progressive loading.',
    includes:
      'Includes exercises for balance, unilateral control, eccentric strength and functional movement, plus routines for upper body, lower body and full-body training.',
    idealFor: 'Designed to support stronger and more controlled movement over time.',
    value: 12,
  },
  {
    number: '05',
    name: 'Warm-Up & Stretching',
    summary: 'Ready-to-use warm-up and stretching protocols for different body areas and training sessions.',
    includes:
      'Includes dynamic preparation, joint mobility, muscle activation and post-training stretching for upper body, lower body and full-body sessions.',
    idealFor: 'A practical resource for organizing what to do before and after training.',
    value: 10,
  },
]

export const pricing = {
  bonusValue: 61,
  price: '26.90',
}

export const checkoutFeatures = [
  '5 Complete Rehabilitation & Strengthening Volumes',
  '5 Practical Bonuses',
  'Beginner → Intermediate → Advanced',
  'Mobility + Strength + Stability',
  'Sets + Reps + Rest Included',
  'Regressions + Progressions',
  'Home + Gym Exercise Options',
  'Ready-to-Follow Routines',
  'Instant Digital Access',
  '7-Day Guarantee',
]
